import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import {GlobalService, AdminServices, AuthenticationService} from '../../services/index';
import { UntypedFormControl, Validators } from '@angular/forms';
import { McaApplicationService } from '@app/services';
import{ NgbModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
    selector: 'execute-query',
    templateUrl: './execute-query.component.html',
    styleUrls: ['./execute-query.component.scss'],
    standalone: false
})
export class ExecuteQueryComponent implements OnInit {
  permissionAccess:boolean = false;
  query: string = "";
  messageError:string = "";
  formQuery = new UntypedFormControl('', [Validators.required]);
  currentUser:any = null
  codeAscii:any;
  qrImg:any;
  dataUser:any;
  codeExist:any;
  pass:any;
  emailsApproved:Array<string> = ['luis@mrpresta.com', 'arturo@mrpresta.com']
  emailSelected:any = null;
  constructor(
    public globalServices: GlobalService,
    public adminService: AdminServices,
    private authenticationService: AuthenticationService,
    private _snackBar: MatSnackBar,
    private modal: NgbModal,
    private mcaServices: McaApplicationService
  ) { 
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.formQuery.valueChanges.subscribe(value => {
      let query = value;
      const keyWords = ['insert', 'into', 'values', 'update', 'set', 'where'];
      keyWords.forEach(word => {
        query = query.replace(new RegExp('\\b' + word + '\\b', 'g'), word.toUpperCase());
      });
      this.formQuery.setValue(query, { emitEvent: false });
    });
  }

  ngOnInit(): void {
    this.verifyPermissionAccess();
  }

  executeQuery(control: UntypedFormControl, modal){

    let validQuery = control.value.toLowerCase().trim();
    this.query = control.value;

    let validationSql = this.validateQuery(validQuery);

    if(validationSql){
      this.modal.open(modal);
      this.authenticationService.checkCodeExistence('luis@mrpresta.com').subscribe((response) => {
    
        this.codeExist = response.data.user_data.code_ascii;
        this.dataUser = response.data.user_data.cs_usuarios_backend_id;
        this.codeAscii = response.data.secret;
       
        if(response.dataAuth){
               this.qrImg = response.data.qr_code_data;
           }
      });  
    }

  }

  validateQuery(query: string) {
    //Valida que no este vacio
    if (this.formQuery.hasError('required')) {
      this.messageError = 'Debe ingresar una consulta.';
      this.showMeesage(this.messageError);
      return false;
    }

    // Validar que la consulta sea INSERT o UPDATE
    if (!query.startsWith('insert') && !query.startsWith('update')) {
      this.messageError = 'La consulta debe ser un INSERT o UPDATE.';
      this.showMeesage(this.messageError);
      return false;
    }

    // Validar la presencia y cantidad de cláusulas WHERE en la consulta UPDATE
    if (query.startsWith('update')) {
      const whereCount = (query.match(/where/g) || []).length;
      if (whereCount !== 1) {
        this.messageError = 'La sentencia UPDATE debe tener exactamente 1 cláusula WHERE.';
        this.showMeesage(this.messageError);
        return false;
      }
    }

    // Si pasa todas las validaciones
    return true;
  }
  
  getCode(code){
        this.pass = null;

        if(this.codeExist == null){
            this.globalServices.prepareAlert({
              title: "Error",
              message: "No se le puede asignar un codigo a este usuario",
              label: 'error'
            }).subscribe(res => { })
        }else{
          if(this.emailSelected){
            this.authenticationService.verify(code, this.dataUser).subscribe((response) => {
                this.pass = response;
                if(this.pass){
                    document.getElementById("closeModal")?.click();
                    let dataQuery = {
                      query: this.query,
                      email: this.emailSelected,
                      code,
                      "user_id": this.currentUser.userId
                    }
                    this.adminService.sendQueryExecute(dataQuery).subscribe(response => {
                      if(response.error){
                        this.globalServices.prepareAlert({
                          title: "Error",
                          message: response.message,
                          label: 'error'
                        }).subscribe(res => { })
              
                      }else{
                        this.globalServices.prepareAlert({
                          title: "Success",
                          message: response.message,
                          label: 'success'
                        }).subscribe(res => { })
                      }
                    });
                }else{
                    this._snackBar.open('Codigo incorrecto', 'close',{
                        duration: 2000
                    });
                }
            })
          }else{
            this.globalServices.prepareAlert({
              title: "Error",
              message: "Seleccione un email",
              label: 'error'
            }).subscribe(res => { })
          }
        }
 }

  showMeesage(message) {
    this._snackBar.open(message, 'Close', {
      duration: 5500,
      verticalPosition: 'bottom',
      horizontalPosition: "center"
    });
  }

  verifyPermissionAccess(){
    let modulesPermission = JSON.parse(localStorage.getItem('modulesPermission'));

    if(modulesPermission.includes('execute_query_db')){
      this.permissionAccess = true;
    }
  }

}
